<div class="scorecard-description-actions">
  <ng-container *ngIf="!scorecardDescription.isCompleted && !scorecardDescription?.isLocked">
    <ng-template [ngTemplateOutlet]="scorecardActions"></ng-template>
  </ng-container>

  <ng-template #scorecardActions>
    <ng-container *ngIf="scorecardDescription.currentScorecard || scorecardMilestone">
      <div class="w-100" [ngClass]="{ show: showMore }">
        <ng-container [ngSwitch]="scorecardDescription?.currentScorecard.ScoreCardDisplayType">
          <!--Punchcard View-->
          <ng-container
            *ngIf="
              scorecardDescription.currentScorecard.ScoreCardDisplayType == scorecardDisplayType.punchcardView ||
              scorecardDescription.currentScorecard.ScoreCardDisplayType == scorecardDisplayType.soloAction ||
              scorecardDescription.currentScorecard.ScoreCardDisplayType == scorecardDisplayType.singleAction
            "
          >
            <!--Middle content-->
            <div
              class="scorecard-actions-completed scorecard-punchcard-description-steps"
              id="scorecard-actions-completed-punchcard"
              *ngIf="!scorecardDescription.isLocked"
            >
              <span class="scorecard-description-completed-text">{{ 'scorecard.completed.steps' | translate }}</span>
              <span class="scorecard-description-action-completed"
                >{{ scorecardDescription.currentScorecard.ActionsCompleted }}/{{
                  scorecardDescription.currentScorecard.Actions.length
                }}</span
              >
              <div class="scorecard-desciprtion-time-completed" *ngIf="scorecardDescription.isCompleted">
                {{ scorecardDescription.currentScorecard?.CompletionDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
              </div>
            </div>
            <ng-container
              *ngIf="
                scorecardDescription.currentScorecard.ScoreCardDisplayType === scorecardDisplayType.punchcardView ||
                scorecardDescription.currentScorecard.ScoreCardDisplayType === scorecardDisplayType.singleAction
              "
            >
              <div class="wrap-scorecard-punches">
                <!--Scorecard punches-->
                <div
                  class="d-flex flex-wrap scorecard-descriptions-actions-container"
                  [ngStyle]="{
                    height:
                      scorecardDescription.currentScorecard.ScoreCardDisplayType === scorecardDisplayType.punchcardView
                        ? 'unset'
                        : '',
                  }"
                  [ngClass]="{
                    'scorecard-punches flex-column':
                      scorecardDescription.currentScorecard.ScoreCardDisplayType === scorecardDisplayType.punchcardView,
                    'punch-spacing':
                      scorecardDescription.currentScorecard.ScoreCardDisplayType == scorecardDisplayType.singleAction,
                  }"
                >
                  <ng-container *ngFor="let action of scorecardDescription.currentScorecard.Actions; index as j">
                    <div
                      class="text-center"
                      [ngClass]="{
                        'my-4':
                          scorecardDescription.currentScorecard.Actions.length <= 5 &&
                          scorecardDescription.currentScorecard.ScoreCardDisplayType !== scorecardDisplayType.punchcardView,
                        'scorecard-punchcardview':
                          scorecardDescription.currentScorecard.ScoreCardDisplayType === scorecardDisplayType.punchcardView,
                        'scorecard-punchcardview-incompleted':
                          scorecardDescription.currentScorecard.ScoreCardDisplayType === scorecardDisplayType.punchcardView &&
                          !action.ActionCompleted,
                        'scorecard-action-drop-out': isActionToggled(action),
                        'scorecard-action-drop-in': !isActionToggled(action),
                      }"
                    >
                      <div
                        class="action-img-container border rounded-circle d-flex"
                        [ngClass]="{
                          'action-completed': action.ActionCompleted,
                          'action-incompleted': !action.ActionCompleted,
                          'm-auto':
                            scorecardDescription.currentScorecard.ScoreCardDisplayType !== scorecardDisplayType.punchcardView,
                        }"
                      >
                        <img
                          alt=""
                          class="scorecard-action-img m-auto"
                          [ngClass]="{
                            'action-completed': action.ActionCompleted,
                            'action-incompleted': !action.ActionCompleted,
                            'm-0': scorecardDescription.currentScorecard.ScorecardCategory === category.defaultView,
                          }"
                          src="{{ action.Image | contentImage: '6' }}"
                          draggable="false"
                        />
                      </div>
                      <ng-container
                        *ngIf="scorecardDescription.currentScorecard.ScoreCardDisplayType === scorecardDisplayType.punchcardView"
                      >
                        <div class="d-flex justify-content-between align-items-center flex-grow-1">
                          <p class="mb-lg-0 scorecard-punch-text-model">
                            {{ action?.Content[0]?.Name }}
                          </p>
                          <ng-container
                            *ngIf="
                              action.LoyaltyActionId && !action.ActionCompleted && isLoyaltyActionIdValid(action.LoyaltyActionId)
                            "
                          >
                            <span class="material-icons cursor-pointer" (click)="toggleShowAction(action)">
                              {{ isActionToggled(action) ? 'remove' : 'add' }}
                            </span>
                          </ng-container>
                        </div>
                        <!-- <span *ngIf="!action.ActionCompleted" class="material-icons ms-auto">add</span> -->
                      </ng-container>
                      <ng-container
                        *ngIf="
                          scorecardDescription.currentScorecard.ScoreCardDisplayType === scorecardDisplayType.punchcardView &&
                          !action.ActionCompleted
                        "
                      >
                        <div
                          (click)="executeAction(action)"
                          class="mt-3 action-link-item font-size-14 text-white d-flex justify-content-between align-items-center w-100"
                        >
                          <span class="fw-bold">
                            {{ 'fgbcl.scorecard.action.go.to' | translate }} {{ action?.Content[0]?.Name }}
                          </span>
                          <div class="rounded bg-white d-flex align-items-center">
                            <span class="icons material-icons text-primary cursor-pointer">chevron_right</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <ng-container
                      *ngIf="
                        scorecardDescription.currentScorecard.Actions.length > 5 &&
                        scorecardDescription.currentScorecard.ScoreCardDisplayType === scorecardDisplayType.singleAction &&
                        j == lineBreakIndex
                      "
                    >
                      <div class="w-100 my-1"></div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <!--Milestone Progress View-->
          <ng-container *ngSwitchCase="scorecardDisplayType.milestoneProgressBarView">
            <div
              class="scorecard-actions-completed scorecard-milestone-description-steps"
              id="scorecard-actions-completed-milestones"
            >
              <span class="scorecard-description-completed-text">{{ 'scorecard.completed.steps' | translate }}</span>
              <span class="scorecard-description-action-completed">
                {{ scorecardMilestone?.Milestone?.CustomerValue }}/{{ maxMilestone }}</span
              >
              <div class="scorecard-desciprtion-time-completed" *ngIf="scorecardDescription.isCompleted">
                {{ scorecardDescription?.currentScorecard?.CompletionDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
              </div>
            </div>
            <!--Progress bar-->
            <div
              class="d-flex flex-column position-relative progress-bar-block-v2 pt-2"
              [ngClass]="{ 'mb-4': !scorecardMilestone?.Milestone?.DisplayMilestones }"
            >
              <div
                class="progress milestone-progress-bar"
                [ngClass]="{ isMilestoneNotReachedTwoLastest: isMilestoneNotReachedTwoLastest }"
              >
                <div
                  id="scorecard-milestone-bar"
                  class="progress-bar"
                  role="progressbar"
                  aria-labelledby="scorecard-actions-completed-milestones"
                  [style.width.%]="currentProgressValue"
                  [attr.aria-valuenow]="currentProgressValue"
                  aria-valuemin="0"
                  aria-valuemax="maxMilestone"
                ></div>
              </div>
              <ng-container *ngIf="!scorecardMilestone?.Milestone?.DisplayMilestones">
                <div
                  [ngClass]="{
                    'scorecard-description-circle-filled': currentProgressValue <= 100,
                    'scorecard-description-circle-empty': currentProgressValue < 100,
                  }"
                  class="milestone-progress-bar-last-circle-model"
                ></div>
              </ng-container>
            </div>
            <!--milestone marking and label under progress bar-->
            <ng-container *ngIf="scorecardMilestone?.Milestone?.DisplayMilestones">
              <div class="position-relative mb-5 pb-2">
                <ng-container *ngFor="let milestoneSpacing of allMilestoneSpacing; index as i; last as last">
                  <!-- <div class="dashed-line-model-v2 position-absolute" [ngStyle]="{ left: milestoneSpacing + '%' }"></div> -->
                  <div
                    class="milestone-progress-bar-circle-model"
                    [ngClass]="{
                      'scorecard-description-circle-filled': milestoneSpacing <= currentProgressValue,
                      'scorecard-description-circle-empty': milestoneSpacing > currentProgressValue,
                    }"
                    [ngStyle]="{
                      left:
                        milestoneSpacing -
                        alignmentOfMilestoneCircle -
                        (last && isMilestoneNotReachedTwoLastest ? alignMilestoneNotReachedTwoLastest : 0) +
                        '%',
                    }"
                  ></div>

                  <div
                    class="scorecard-description-milestone-value position-absolute pt-3 pe-1"
                    [ngStyle]="{
                      left:
                        milestoneSpacing -
                        alignmentOfMilestoneValue -
                        (last && isMilestoneNotReachedTwoLastest ? alignMilestoneNotReachedTwoLastest : 0) +
                        '%',
                    }"
                  >
                    {{ scorecardMilestone?.Milestone?.Milestones[i]?.Value }}
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>

          <!--Number View-->
          <ng-container *ngSwitchCase="scorecardDisplayType.numberView">
            <div class="d-flex flex-column justify-content-center">
              <!-- SHOW STEP AND TIME COMPLETED WHEN SCORECARD COMPLETED -->
              <ng-container *ngIf="scorecardDescription.currentScorecard.Completed">
                <div
                  class="scorecard-actions-completed scorecard-number-view-description-steps"
                  id="scorecard-actions-completed-number-view"
                >
                  <span class="scorecard-description-completed-text">{{ 'scorecard.completed.steps' | translate }}</span>
                  <div class="scorecard-desciprtion-time-completed" *ngIf="scorecardDescription.isCompleted">
                    {{ scorecardDescription.currentScorecard.CompletionDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
                  </div>
                </div>
              </ng-container>
              <h1 class="text-center counter-number-scorecard" id="scorecard-actions-completed-number">
                <span class="numberview-action-completed counter-number-scorecard">{{
                  scorecardDescription.currentScorecard.ActionsCompleted
                }}</span>
                <span
                  class="numberview-action-counter-limit counter-number-scorecard"
                  *ngIf="scorecardDescription.currentScorecard.DisplayCounterLimit"
                >
                  <span class="slash">/</span>
                  <span class="limit-number">{{ scorecardDescription.currentScorecard.Actions.length }}</span>
                </span>
              </h1>
            </div>
          </ng-container>

          <!--Streak View-->
          <ng-container *ngSwitchCase="scorecardDisplayType.streakView">
            <div class="d-flex align-items-center justify-content-center streak-progress">
              <h1 class="text-center text-primary streak-number-value">
                {{ scorecardDescription.currentScorecard.Milestone?.CustomerValue ?? 0 }}
              </h1>

              <img
                *ngIf="scorecardDescription.currentScorecard.Milestone?.CustomerValue > 0"
                class="streak-logo"
                src="assets/images/placeholders/FireIcon.svg"
              />
            </div>
          </ng-container>

          <!--Progress View-->
          <ng-container *ngSwitchCase="scorecardDisplayType.progressBarView">
            <div class="scorecard-actions-completed" id="scorecard-actions-completed-progress">
              {{ scorecardDescription.currentScorecard.ActionsCompleted }}/{{
                scorecardDescription.currentScorecard.TotalToComplete
              }}
            </div>
            <!--Progress bar-->
            <div class="d-flex flex-column">
              <div class="progress position-relative">
                <div
                  id="scorecard-progress-bar"
                  class="progress-bar"
                  role="progressbar"
                  aria-labelledby="scorecard-actions-completed-progress"
                  [style.width.%]="
                    (scorecardDescription.currentScorecard.ActionsCompleted * 100) /
                    scorecardDescription.currentScorecard.Actions.length
                  "
                  [attr.aria-valuenow]="scorecardDescription.currentScorecard.ActionsCompleted"
                  aria-valuemin="0"
                  [attr.aria-valuemax]="scorecardDescription.currentScorecard.Actions.length"
                ></div>
              </div>
            </div>
            <!--action marking and label under progress bar-->
            <div class="position-relative mb-5 pb-2">
              <ng-container *ngFor="let actionSpacing of allActionSpacing; index as i">
                <div class="dashed-line position-absolute" [ngStyle]="{ left: actionSpacing + '%' }"></div>
                <div
                  class="position-absolute pt-3 font-size-14 pe-1 fw-bold text-primary"
                  [ngStyle]="{ left: 'calc(' + actionSpacing + '%' + ' - ' + alignmentOfMilestoneValue + ')' }"
                >
                  {{ scorecardDescription.currentScorecard.Actions[i].Content[0].Name }}
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>

  <ng-container *ngIf="!scorecardDescription.isLocked">
    <ng-container *ngIf="!scorecardDescription.isCompleted">
      <ng-template [ngTemplateOutlet]="descriptionAndTerm"></ng-template>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="scorecardDescription.isCompleted">
    <ng-container *ngIf="invisibleShowMore">
      <button class="btn scorecard-description-more-btn cursor-pointer" (click)="toggleShowMore()">
        <span [ngClass]="{ rotate: showMore }" class="material-icons">chevron_right</span>
        <span class="scorecard-description-more-details">More Details</span>
      </button>
      <ng-container *ngIf="showMore">
        <ng-template [ngTemplateOutlet]="scorecardActions"></ng-template>
        <ng-template [ngTemplateOutlet]="descriptionAndTerm"></ng-template>
      </ng-container>
    </ng-container>
  </ng-container>
  <!-- Description & Terms Nav -->
  <ng-template #descriptionAndTerm>
    <div class="scorecard-description-desc-terms accordion accordion-flush" id="scorecard-desc-terms">
      <div class="accordion-item" *ngIf="scorecardDescription.currentScorecard?.Content[0]?.Description">
        <div class="accordion-header">
          <button
            class="accordion-button shadow-none scorecard-description-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#scorecard-desc"
            aria-expanded="false"
          >
            {{ 'scorecard.description.label' | translate }}
          </button>
        </div>
        <div id="scorecard-desc" class="accordion-collapse collapse show" data-bs-parent="#scorecard-desc-terms">
          <fgbcl-short-long-description
            id="scorecard-description-id"
            [description]="scorecardDescription.currentScorecard.Content[0].Description"
            [descriptionLength]="580"
            [descriptionLengthMobile]="400"
          >
          </fgbcl-short-long-description>
        </div>
      </div>
      <div class="accordion-item" *ngIf="scorecardDescription.currentScorecard?.ShowTermsAndConditions">
        <div class="accordion-header">
          <button
            class="accordion-button shadow-none collapsed scorecard-term-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#scorecard-terms"
            aria-expanded="false"
          >
            {{ 'scorecard.terms.label' | translate }}
          </button>
        </div>
        <div id="scorecard-terms" class="accordion-collapse collapse" data-bs-parent="#scorecard-desc-terms">
          <!--Text T&Cs-->
          <ng-container *ngIf="scorecardDescription.currentScorecard?.TermsAndConditionsType === TermsAndCondtionsType.Text">
            <div
              class="scorecard-item-terms-text"
              [innerHtml]="scorecardDescription.currentScorecard?.Content[0].TermsAndConditions | safeHtml"
            ></div>
          </ng-container>
          <!--URL T&Cs-->
          <ng-container *ngIf="scorecardDescription.currentScorecard?.TermsAndConditionsType === TermsAndCondtionsType.URL">
            <a
              [href]="scorecardDescription.currentScorecard?.Content[0].TermsAndConditions"
              target="_blank"
              class="scorecard-item-terms-url"
              id="link-url"
            >
              {{ scorecardDescription.currentScorecard?.Content[0].TermsAndConditions }}
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
</div>
